module.exports = __webpack_public_path__ + "img/brightness-low.032f8f6e.svg";